export default import.meta.ROLLDOWN_FILE_URL_BsIoh2DdRfc6hjAKziqQ8g